import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "mobx-react";
import { Router } from "app-shared-components";
import { Route } from "react-router-dom";
import { enableLogging } from "mobx-logger";
import { AppContainer as HotReloader } from "react-hot-loader";
import { hot } from "react-hot-loader";

// IMPORTANT
// In order for webpack extract-text-plugin to include in shared.css
// styles from shared modules we need to import shared modules
//import * as SharedModules from 'app-shared-modules';

var isDev = true;

import "./numeral/ro";

const loggingConfig = {
	predicate: () => true,
	action: true,
	reaction: false,
	transaction: true,
	compute: false
};

const AppComponent = ({ store, routes, children }) => {
	if (!routes) {
		return <Provider {...store}>{children}</Provider>;
	}

	return (
		<Provider {...store}>
			<Router>
				<Route render={props => React.cloneElement(children, { props, routes })} />
			</Router>
		</Provider>
	);
};

const App = hot(module)(AppComponent);

export default (Component, store, routes, hostId, isDevelopment = true) => {
	var host = document.getElementById(hostId);

	isDev = isDevelopment;
	enableLogging(loggingConfig);

	ReactDOM.render(
		<App store={store} routes={routes}>
			<Component />
		</App>,
		host
	);
};
